<template>
  <div class="app-header">
    <div class="header-left">
      <div class="logo" @click="goToHome">
        <img src="/logo.png" alt="Logo" />
        <span class="system-name">OKAKA</span>
      </div>
    </div>

    <div class="header-right">
      <div class="user-info">
        <div class="user-avatar" @click="toggleUserMenu">
          <img :src="userInfo.avatar || defaultAvatar" :alt="userInfo.username" />
          <span class="user-name">{{ userInfo.username }}</span>
          <i class="fa fa-chevron-down" :class="{ 'rotate': showUserMenu }"></i>
        </div>

        <!-- 用户菜单下拉框 -->
        <div class="user-menu" v-show="showUserMenu" @click.stop>
          <div class="menu-item user-profile-item">
            <div class="user-details">
              <div class="username">{{ userInfo.username }}</div>
              <div class="user-role">{{ getRoleText(userInfo.role) }}</div>
            </div>
          </div>
          <div class="menu-divider"></div>
          <div class="menu-item" @click="goToProfile">
            <i class="fa fa-user"></i>
            <span>个人中心</span>
          </div>
          <div class="menu-item" @click="goToSettings">
            <i class="fa fa-cog"></i>
            <span>设置</span>
          </div>
          <div class="menu-divider"></div>
          <div class="menu-item logout-item" @click="handleLogout">
            <i class="fa fa-sign-out"></i>
            <span>退出登录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      showUserMenu: false,
      defaultAvatar: '/img/def_img.png'
    }
  },
  computed: {
    userInfo() {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        try {
          const parsed = JSON.parse(userInfo);
          return parsed;
        } catch (error) {
          console.error('解析用户信息失败:', error);
          return {
            username: '未登录',
            role: '',
            avatar: ''
          };
        }
      }
      return {
        username: '未登录',
        role: '',
        avatar: ''
      };
    }
  },
  mounted() {
    // 点击其他地方关闭菜单
    document.addEventListener('click', this.closeUserMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeUserMenu);
  },
  methods: {
    toggleUserMenu(event) {
      console.log('toggleUserMenu clicked, current state:', this.showUserMenu);
      event.stopPropagation(); // 阻止事件冒泡
      this.showUserMenu = !this.showUserMenu;
      console.log('toggleUserMenu new state:', this.showUserMenu);
    },

    closeUserMenu(event) {
      // 如果点击的是用户头像区域，不关闭菜单
      if (event && event.target.closest('.user-avatar')) {
        return;
      }
      this.showUserMenu = false;
    },

    getRoleText(role) {
      const roleMap = {
        student: '学生',
        teacher: '教师',
        parent: '家长'
      };
      return roleMap[role] || '';
    },

    goToProfile() {
      console.log('goToProfile clicked, user role:', this.userInfo.role);
      this.closeUserMenu();
      const role = this.userInfo.role;
      const targetRoute = `/${role}/profile`;
      console.log('Navigating to:', targetRoute);
      this.$router.push(targetRoute);
    },

    goToSettings() {
      this.closeUserMenu();
      // 暂时跳转到个人中心，因为设置页面还未实现
      const role = this.userInfo.role;
      this.$router.push(`/${role}/profile`);
    },

    goToHome() {
      const role = this.userInfo.role;
      if (role) {
        // 根据用户角色跳转到对应的dashboard
        const targetRoute = `/${role}/dashboard`;
        this.$router.push(targetRoute);
      } else {
        // 如果没有角色信息，跳转到登录页
        this.$router.push('/');
      }
    },

    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除本地存储的用户信息
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');

        // 显示退出成功消息
        this.$message({
          message: '已退出登录',
          type: 'success'
        });

        // 跳转到登录页面
        this.$router.push('/');
      }).catch(() => {
        // 用户取消退出
        console.log('用户取消退出');
      });
    }
  }
}
</script>

<style lang="less" scoped>
.app-header {
  height: 60px;
  background: white;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 1000;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }

  .system-name {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    background: linear-gradient(135deg, #667eea, #764ba2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  position: relative;
}

.user-avatar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f7fa;
  }

  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }

  .user-name {
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .fa-chevron-down {
    font-size: 12px;
    color: #7f8c8d;
    transition: transform 0.2s;

    &.rotate {
      transform: rotate(180deg);
    }
  }
}

.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  padding: 8px 0;
  margin-top: 8px;
  z-index: 99999;
  border: 1px solid #e8e8e8;

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    right: 20px;
    width: 12px;
    height: 12px;
    background: white;
    transform: rotate(45deg);
    box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.1);
  }
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f7fa;
  }

  i {
    width: 16px;
    font-size: 14px;
    color: #7f8c8d;
  }

  span {
    font-size: 14px;
    color: #2c3e50;
  }

  &.user-profile-item {
    cursor: default;

    &:hover {
      background-color: transparent;
    }
  }

  &.logout-item {
    &:hover {
      background-color: #fff5f5;

      i, span {
        color: #e74c3c;
      }
    }
  }
}

.user-details {
  .username {
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 2px;
  }

  .user-role {
    font-size: 12px;
    color: #7f8c8d;
  }
}

.menu-divider {
  height: 1px;
  background-color: #e8e8e8;
  margin: 8px 0;
}

// 响应式设计
@media (max-width: 768px) {
  .app-header {
    padding: 0 16px;
  }

  .system-name {
    display: none;
  }

  .user-name {
    display: none;
  }

  .user-menu {
    right: -8px;
    min-width: 180px;
  }
}
</style>
